import React, { useMemo } from "react";
import { Modal, MimaText } from "../../components";
import moment from "moment";
import { walletStore } from "../../stores";
import { amountFormatter } from "../../utils/utils";

const ViewInflowModal = ({ closeModal }) => {
  const inflowData = walletStore.inflowData;

  const invoice = inflowData.invoice;
  const viaFashWebsite = invoice?.orders?.[0]?.style;
  const createdManually = inflowData?.createdBy?._id;
  const createdBy = inflowData?.createdBy;
  const chargeSplit = inflowData?.chargeSplit;
  const vendor = inflowData?.vendor;
  const createdAt = inflowData.createdAt;
  const formattedCreatedAt = moment(createdAt).format("DD/MM/YYYY HH:MM A");
  const updatedBy = inflowData?.updatedBy;
  const updatedAt = inflowData?.updatedAt;
  const formattedUpdatedAt = moment(updatedAt).format("DD/MM/YYYY HH:MM A");
  const status = inflowData?.status;
  const styleClass = `status ${status === "FULLY-PAID" || status === "PAID" ? "status__green" : status === "PENDING" ? "status__dark__yellow" : status === "VOID" || status === "REVERSED" ? "status__grey" : "status__dark__yellow"}`;
  const orders = inflowData?.invoice?.orders || [];

  const details = useMemo(() => {
    return [
      {
        label: "Business Name",
        value: inflowData.business.tradingName,
      },
      {
        label: "Created Date",
        value: formattedCreatedAt,
      },
      ...(updatedBy
        ? [
            {
              label: "Approved by",
              value: `${updatedBy?.firstname} ${updatedBy?.lastname} `,
            },
            { label: "Approved Date", value: formattedUpdatedAt },
          ]
        : []),

      {
        label: "Payment Channel",
        value: viaFashWebsite
          ? `Fash Website Order`
          : createdManually
            ? `Created Manually`
            : "invoice or Payment link",
      },
      ...(createdManually
        ? [
            {
              label: "Created by",
              value: `${createdBy?.firstname} ${createdBy?.lastname}` || "N/A",
            },
          ]
        : []),
      {
        label: "Narration",
        value:
          inflowData?.narration ||
          `Payment for Invoice ${inflowData?.invoiceNumber}`,
      },
      {
        label: "Amount Paid",
        value: amountFormatter(inflowData.currencyCode).format(
          inflowData?.amountPaid,
        ),
      },
      {
        label: "Charge Split",
        value: chargeSplit || "N/A",
      },
    ];
  }, [
    chargeSplit,
    createdBy?.firstname,
    createdBy?.lastname,
    createdManually,
    formattedCreatedAt,
    formattedUpdatedAt,
    inflowData?.amountPaid,
    inflowData.business.tradingName,
    inflowData.currencyCode,
    inflowData?.invoiceNumber,
    inflowData?.narration,
    updatedBy,
    viaFashWebsite,
  ]);

  const totalInvoicePrice = orders.reduce((total, order) => {
    return total + order.quantity * order.unitPrice;
  }, 0);

  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" mb={1}>
        View Inflow Details
      </MimaText>
      <MimaText
        variant="h3"
        mb={1}
        labelTitle={
          createdManually
            ? "Manual Credit Full Amount"
            : `Full ${vendor} Amount`
        }
        align="center"
      >
        {amountFormatter(inflowData.currencyCode).format(inflowData.amountPaid)}{" "}
      </MimaText>
      {!createdManually && (
        <MimaText variant="small" mb={1} mt={-1} align="center">
          {`Total Invoice Price: ${amountFormatter(
            inflowData.currencyCode,
          ).format(totalInvoicePrice)}`}
        </MimaText>
      )}
      <span className={styleClass}>{status}</span>;
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "2rem",
          width: "38rem",
        }}
      >
        {details.map((detail, index) => (
          <MimaText key={index} variant="body" labelTitle={detail.label}>
            {detail.value}
          </MimaText>
        ))}
      </div>
      {!createdManually && (
        <>
          <MimaText variant="subtitleBold" mt={3}>
            Invoice and Order Details
          </MimaText>
          <MimaText variant="body" mb={1}>
            {`Invoice Number: ${inflowData?.invoiceNumber}`}
          </MimaText>
          <div>
            {orders.map((order, index) => {
              const orderDetails = [
                {
                  label: `Invoice Item ${index + 1}`,
                  value: order.item,
                },
                {
                  label: `Invoice Item ${index + 1} Total Price`,
                  value: order.itemPrice,
                },
                {
                  label: `Invoice Item ${index + 1} Quantity`,
                  value: order.quantity,
                },
                {
                  label: `Invoice Item ${index + 1} Unit Price`,
                  value: order.unitPrice,
                },
              ];

              return (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: "2rem",
                    borderBottom: "1px solid var(--color-grey-3)",
                    paddingBottom: "1rem",
                    marginBottom: "1rem",
                    width: "38rem",
                  }}
                >
                  {orderDetails.map((detail, index) => (
                    <MimaText
                      key={index}
                      variant="body"
                      labelTitle={detail.label}
                    >
                      {detail.value}
                    </MimaText>
                  ))}
                </div>
              );
            })}
          </div>
          <MimaText variant="bodyBold" mb={1} mt={3}>
            {`Total Invoice Price: ${amountFormatter(
              inflowData.currencyCode,
            ).format(totalInvoicePrice)}`}
          </MimaText>
        </>
      )}
    </Modal>
  );
};

export default ViewInflowModal;
